import React, { useEffect, useState } from "react";
import "../App.scss";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  Outlet,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import { connect, useSelector } from "react-redux";
import moment from "moment-timezone";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  FloatingButton,
  Text,
  SwipeTabs,
  SwipeTab,
} from "../styles/Global";
import * as Global from "../styles/Global";
import {
  Menu,
  Item,
  Separator,
  Submenu,
  MenuProvider,
  useContextMenu,
  animation,
} from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import {
  AiFillCloseCircle,
  AiFillEyeInvisible,
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { HiBeaker } from "react-icons/hi";
import { SVGIcon } from "./CustomSVG";
import SlideUp from "./modals/SlideUp";
import { setModal } from "../features/modals/modalSlice";
import { BsCurrencyDollar, BsShieldShaded } from "react-icons/bs";
import { BiSolidDollarCircle, BiTestTube } from "react-icons/bi";
import { FaDollarSign, FaEyeSlash } from "react-icons/fa";
import { GrTest } from "react-icons/gr";
import { OrgAssistIcon } from "../assets/sport/icons/orgAssistIcon";
import CircularProgress from "./ProgressBars/CircularProgress";
import ProgressBar from "./ProgressBars/ProgressBar";
import { allAccessOrganizers } from "../pages/organizer/forms/formSelectArrays";
import HelipadIcon from "../assets/icons/HelipadIcon";

const mapDispatch = { setModal };

const GridCustomEvents = ({ data, setModal }) => {
  const eventData = data;
  const [displayModal, setDisplayModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const darkMode = useSelector((state) => state.global.darkMode);
  const account = useSelector((state) => state.organizer.accountid);
  // console.log("GridCustomEvents eventData: ", eventData);
  const { show } = useContextMenu({
    id: eventData.gameid,
  });

  function displayMenu(e) {
    console.log("displayMenu: ", e.clientX);
    // pass the item id so the `onClick` on the `Item` has access to it
    show(e, {
      props: { id: Number(e.currentTarget.id) },
      position: {
        x: 10,
        y: 10,
      },
    });
  }

  function handleItemClick() {
    setModal({ organizerEvent: { showModal: true, data: eventData } });
  }

  console.log("GridCustomEvents displayModal: ", displayModal);
  console.log("GridCustomEvents eventData: ", eventData);

  function SetEventColor(opacity) {
    let color = "#fff";
    switch (eventData.teamcreate) {
      case "Singles":
        color = opacity === 99 ? "#d07a2d" : `#d07a2d${opacity}`;
        break;
      case "Blind Draw":
        color = opacity === 99 ? `#43922a` : `#43922a${opacity}`;
        break;
      case "Set Teams":
        color = opacity === 99 ? `#3576a4` : `#3576a4${opacity}`;
        break;
      case "Switcholio":
        color = darkMode
          ? opacity === 99
            ? `#895ADB`
            : `#895ADB${opacity}`
          : `#4b3179${opacity}`;
        break;
      case "Split Switch":
        color = opacity === 99 ? `#CC0C0D` : `#CC0C0D${opacity}`;
        break;
      case "Squadholio":
        color = opacity === 99 ? `#bb9b34` : `#bb9b34${opacity}`;
        break;
      case "MultiMatch":
        color = darkMode
          ? opacity === 99
            ? `#9a8f83`
            : `#9a8f83${opacity}`
          : `#5D3911${opacity}`;
        break;
      default:
        color = `#333${opacity}`;
        break;
    }
    return color;
  }

  const isInProgress = eventData.hasOwnProperty("progress")
    ? eventData.progress.percent > 0
    : false;

  return (
    <>
      {displayModal && (
        <SlideUp
          setDisplayModal={setDisplayModal}
          modalData={eventData}
          modalType={12}
        />
      )}
      <FlexColumn
        className="eventListItem"
        style={{
          flex: 1,
          // padding: 5,
          // margin: "0 3px",
          // backgroundColor: "#fff",
          backgroundColor: SetEventColor(20),
          marginBottom: 13,
          marginTop: 3,
          border: "1px solid #949CC160",
          borderColor: SetEventColor(99),
          position: "relative",
          cursor: "pointer",
          overflow: "hidden",
        }}
        onClick={handleItemClick}
        id={eventData.gameid}
      >
        <FlexRow
          justify="space-between"
          align="flex-start"
          style={{ alignSelf: "stretch" }}
        >
          <FlexRow align="center" style={{ flex: 0 }}>
            {/* {eventData.hasOwnProperty("progress") &&
            eventData.progress.percent > 0 ? (
              <CircularProgress
                percent={
                  eventData.hasOwnProperty("progress")
                    ? eventData.progress.percent || 0
                    : 0
                }
                data={eventData}
                size={25}
                style={{marginRight: 3,}}
                fontSize='.8em'
              />
            ) : ( */}
            {SVGIcon(eventData, SetEventColor)}
            {/* )} */}
            <FlexColumn style={{ flex: 0 }}>
              <Text
                size="1.1em"
                color={SetEventColor(99)}
                style={{
                  fontWeight: "900",
                  marginTop: 2,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  marginBottom: 0,
                  padding: 0,
                  textShadow: `0 1px 0px rgba(0,0,0,.1)`,
                }}
              >
                {eventData.teamcreate}
              </Text>
              <Text
                size="1em"
                color={SetEventColor(99)}
                style={{
                  textShadow: `0 1px 0px rgba(0,0,0,.1)`,
                  // fontWeight: "900",
                  // marginTop: -7,

                  textTransform: "uppercase",
                  // letterSpacing: 1,
                }}
              >
                {eventData.format}
              </Text>
            </FlexColumn>

            {/* {(eventData.type === "Test" ||
              eventData.gamevisibility === "Private") && (
              <div
                style={{
                  padding: "0 3px 2px",
                  borderRadius: 20,
                  marginLeft: 5,
                  background: Global.redLight,
                  boxShadow: "0 2px 2px rgba(0,0,0,.3)",
                }}
              >
                <Text
                  size=".7em"
                  color="#fff"
                  style={{
                    fontWeight: "800",
                    lineHeight: ".7em",
                  }}
                > 
                  {eventData.type === "Test" &&
                    `TEST${eventData.gamevisibility === "Private" ? "/" : ""}`}
                  {eventData.gamevisibility === "Private" && "PRIV"}
                </Text>
              </div>
            )} */}
          </FlexRow>
          {!eventData.template && (
            <FlexColumn align="flex-end" style={{ marginTop: 1, flex: 1 }}>
              <Text
                size=".8em"
                style={{
                  paddingRight: 5,
                  whiteSpace: "normal",
                  textAlign: "right",
                }}
              >
                {eventData.hasOwnProperty("timezone")
                  ? moment
                      .tz(eventData.gametime * 1000, eventData.timezone)
                      .format("ddd, MMM D, YYYY h:mma z")
                  : "No Date"}
              </Text>
              <FlexRow
                align="center"
                justify="flex-end"
                style={{ flex: 1, paddingRight: 5 }}
              >
                <Text
                  size=".8em"
                  // color={SetEventColor(99)}

                  style={{ fontWeight: "800" }}
                >
                  {!eventData.gameregistered
                    ? 0
                    : eventData.gamemaxteams > 0
                    ? `${eventData.gameregistered}/${eventData.gamemaxteams}`
                    : `${eventData.gameregistered}`}
                </Text>
                <Text size=".8em" style={{ marginLeft: 2 }}>
                  Reg
                </Text>
                {eventData.waitlist === "Yes" &&
                eventData.waitlistCount &&
                eventData.waitlistCount > 0 ? (
                  <>
                    <>
                      <Text size=".8em" style={{ padding: "0 2px" }}>
                        -
                      </Text>
                    </>
                    <>
                      <Text
                        size=".8em"
                        // color={SetEventColor(99)}

                        style={{ fontWeight: "800" }}
                      >
                        {eventData.waitlistCount}
                      </Text>
                      <Text size=".8em" style={{ marginLeft: 2 }}>
                        Wait
                      </Text>
                    </>
                  </>
                ) : null}
              </FlexRow>
            </FlexColumn>
          )}
        </FlexRow>

        <Text
          size="1.4em"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "97%",
            padding: `${
              eventData.template
                ? "5px"
                // : isInProgress
                // ? "0"
                : eventData.teamcreate === "MultiMatch"
                ? "7px"
                : "15px"
            } 5px 0`,
          }}
        >
          {eventData.name}
        </Text>
        {!eventData.template && (
          <FlexRow style={{ width: "100%" }} align="center">
            <Text
              size=".9em"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "97%",
                margin: "0 5px",
              }}
            >
              {eventData.locationfullname}
            </Text>
            {eventData.organizerAssist && (
              <OrgAssistIcon
                width={20}
                height={15}
                color={Global.redLight}
                style={{ marginLeft: 5 }}
              />
            )}
            {eventData.gameprepaytype !== "Do not accept Payments" && (
              <FaDollarSign
                size={14}
                color={Global.redLight}
                style={{ marginLeft: 5 }}
              />
            )}
            {(eventData.type === "Test" ||
              eventData.gamevisibility === "Private") && (
              <FlexRow style={{ marginRight: 5 }}>
                {eventData.type === "Test" && (
                  <HiBeaker
                    size={15}
                    color={Global.redLight}
                    style={{ marginLeft: 5, stroke: Global.redLight }}
                  />
                )}
                {eventData.gamevisibility === "Private" && (
                  <>
                    <FaEyeSlash
                      size={15}
                      color={Global.redLight}
                      style={{ marginLeft: 5 }}
                    />
                  </>
                )}
              </FlexRow>
            )}
            {eventData.hasOwnProperty("restrictionsCount") &&
              eventData.restrictionsCount > 0 && (
                <BsShieldShaded size={15} color={Global.redLight} />
              )}
            {eventData.hasOwnProperty("handicap") && eventData.handicap &&
              eventData.handicap.hasOwnProperty("enabled") &&
              eventData.handicap.enabled && (
                <HelipadIcon
                  color={Global.redLight}
                  width="17px"
                  height="17px"
                />
              )}
            {/* <CircularProgress
            percent={
              eventData.hasOwnProperty("progress")
                ? eventData.progress.percent || 0
                : 0
            }
            data={eventData}
            size={20}
          /> */}
          </FlexRow>
        )}

        {allAccessOrganizers.includes(account) && isInProgress && (
          <ProgressBar
            percent={
              eventData.hasOwnProperty("progress")
                ? eventData.progress.percent || 0
                : 0
            }
            data={eventData}
          />
        )}
      </FlexColumn>
    </>
  );
};

export default connect(null, mapDispatch)(GridCustomEvents);
